import { useCallback, useEffect, useState } from 'react';
import {
  DEMO_MODE_CHANGE_EVENT,
  isDemoMode,
  setDemoMode as persistDemoMode,
} from '../demo/demoConfig';
import { clearAllDemoStorage } from '../demo/demoStorage';

export function useDemoMode() {
  const [enabled, setEnabled] = useState(isDemoMode);

  useEffect(() => {
    const onChange = () => setEnabled(isDemoMode());
    window.addEventListener(DEMO_MODE_CHANGE_EVENT, onChange);
    return () => window.removeEventListener(DEMO_MODE_CHANGE_EVENT, onChange);
  }, []);

  const toggle = useCallback(() => {
    const next = !isDemoMode();
    if (!next) {
      clearAllDemoStorage();
    }
    persistDemoMode(next);
    setEnabled(next);
  }, []);

  const setDemoMode = useCallback((value: boolean) => {
    if (!value) {
      clearAllDemoStorage();
    }
    persistDemoMode(value);
    setEnabled(value);
  }, []);

  return { isDemoMode: enabled, toggle, setDemoMode };
}
